import { render, staticRenderFns } from "./UpdatePay.vue?vue&type=template&id=53c83883&scoped=true"
import script from "./UpdatePay.vue?vue&type=script&lang=js"
export * from "./UpdatePay.vue?vue&type=script&lang=js"
import style0 from "./UpdatePay.vue?vue&type=style&index=0&id=53c83883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c83883",
  null
  
)

export default component.exports